import isNodeTemplate from './isNodeTemplate';
import serviceNeedsAuth from './serviceNeedsAuth';
import { FlowNode } from '../flowState';
import { ServicesMap } from 'app/service/types';

// !!! IMPORTANT !!!
// This function affects the global flows redux state. You
// may need to make the same changes to both the beta-editor
// and classic-editor code. Edit with caution and test thoroughly.
const isValidAuth = (node: FlowNode, services: ServicesMap) => {
  const doesntNeedAuth =
    isNodeTemplate(node) || !serviceNeedsAuth(node, services);
  if (doesntNeedAuth) {
    return true;
  }
  return Boolean(node.authentication_id);
};

export default isValidAuth;
